export default "__VITE_ASSET__B6naMOD7__"